import { ScaleSymLog } from 'd3-scale';

import type {
  DateTimeFormatter,
  FormatterWithPrecision,
  StringFormatter,
} from '../../core/types/formatter.js';
import {
  getCategoricalTicks,
  getDateNumericalFormattedTicks,
  getFormattedTicks,
} from '../../core/utils/formatter-by-ticks.js';
import { isCategorical, isLinear, isLogarithmic } from '../types/guards.js';
import type {
  AnyXYChartScale,
  XYChartAxisInternal,
} from '../types/xy-chart-internals.js';

export function getTicksFormattedByConfig(
  config: XYChartAxisInternal | undefined,
  numTicks: number,
  scale: AnyXYChartScale | undefined,
  formatter:
    | FormatterWithPrecision
    | DateTimeFormatter
    | StringFormatter
    | undefined,
) {
  const axisType = config?.type || '';

  if (isCategorical(axisType)) {
    return getCategoricalTicks(scale, formatter as StringFormatter | undefined);
  }

  if (isLogarithmic(axisType)) {
    return getFormattedTicks(
      numTicks,
      scale as ScaleSymLog<number, never>,
      undefined,
      formatter as FormatterWithPrecision | undefined,
    );
  }

  return getDateNumericalFormattedTicks(
    numTicks,
    scale,
    isLinear(axisType) && !config?.isRelative ? config?.unit : undefined,
    formatter as FormatterWithPrecision | DateTimeFormatter | undefined,
  );
}
